export const FACET_VALUE_ICONS: Record<string, Record<string, string>> = {
  targetAudience: {
    'Cetatean': 'person',
    'Cetățean': 'person',
    'Citizen': 'person',
    'Companie': 'business_center',
    'Company': 'business_center',
    'Institutie': 'account_balance',
    'Instituție': 'account_balance',
    'Institution': 'account_balance'
  },
  typeId: {
    // IDs
    '1': 'assignment', // Procedura
    '2': 'domain',     // Institutie
    '3': 'info',       // Pagina informativa
    // Labels
    'Procedura': 'assignment',
    'Procedură': 'assignment',
    'Procedure': 'assignment',
    'Institutie': 'domain',
    'Instituție': 'domain',
    'Institution': 'domain',
    'Pagina informativa': 'info',
    'Pagină informativă': 'info',
    'Informative page': 'info'
  },
  availabilityTypeId: {
    'Offline': 'android_wifi_4_bar_off',
    'Online': 'android_wifi_4_bar',
    'Partial online': 'cell_wifi',
    'Parțial online': 'cell_wifi'
  },
  areas: {
    'National': 'explore_nearby',
    'Național': 'explore_nearby',
    'Transfrontalier': 'globe_location_pin',
    'Crossborder': 'globe_location_pin'
  }
};
